<template>
  <Layout>
    <!-- <Appdowload></Appdowload> -->
    <div class="bordertop3" v-if="!show_ie">
      <div class="header">
        <HeaderNav name="4"></HeaderNav>
      </div>
      <div class="mall-detail">
        <div class="head container-padding">
          <div class="bread">
            <p>
              <router-link :to="{path:'/mall/index'}">商城</router-link>&nbsp;&nbsp;\&nbsp;&nbsp;舒适柔软瑜伽垫
            </p>
          </div>
          <div class="head-detail">
            <div class="img flt">
              <img v-if="info.image_url==undefined || info.image_url.length<=0"
               src="https://file.jkxuetang.com/khyoga/banner.jpg" />
              <el-carousel width="380px;" height="380px" v-else>
                <el-carousel-item v-for="item in info.image_url" :key="item">
                  <img :src="item" style="width: 380px;height:380px"  />
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="info flt">
              <h1>{{info.product_name}}</h1>
              <div class="jieshao" v-html="info.product_introduction"></div>
              <div class="price-div"  v-if="info.sku.length!=0">
                <span class="price-span">￥{{info.sku[sku_key].price}}</span>
              </div>
              <div class="skus"  v-if="info.sku.length!=0">
                <div
                  v-for="(sku_item,sku_item_key) in info.sku" :key="sku_item_key"
                  @click="changeSkuKey(sku_item_key)"
                  class="sku-item text-nowrap pointer"
                  :class="{active:sku_item_key==sku_key}"
                >{{sku_item.sku_name}}</div>
              </div>
               <div>
               <el-button type="danger" @click="zixun"  class="zixun_button" round>咨询</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="mall-body container-padding">
          <div class="flt train-body-left">
            <div class="detail">
              <div class>
                <h1>商品详情</h1>
              </div>
              <div v-html="info.detail" class="course-content"></div>
            </div>
          </div>
          <div class="flt train-body-right">
            <div class="title">
              <h1>商品规格</h1>
            </div>
            <div class="specification">
              <div v-for="(attr,index) in info.attr_rule" :key="index" class="specification-item">
                <div class="flt">{{attr.attr}}:</div>
                <div class="frt">{{attr.value}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterDes v-if="!show_ie"></FooterDes>
	<HintIE v-if="show_ie"></HintIE>
  </Layout>
</template>

<script>
import { getData, set_cache_item } from "../../../static/js/util.js";
import config from "../../../static/js/myconfig";
import headernav from "../../components/HeaderNav";
import footer from "../../components/FooterDes";
import Appdowload from "../../components/Appdowload";
import HintIE from "../../components/HintIE";
export default {
  components: {
    Appdowload: Appdowload,
    HeaderNav: headernav,
	FooterDes: footer,
	HintIE:HintIE
  },
  data() {
    return {
      info: {},
      id: 0,
	  sku_key: 0,
	  show_ie:false
    };
  },
  methods: {
	isIE() {
      if (!!window.ActiveXObject || "ActiveXObject" in window)this.show_ie = true; //不支付IE
    },
  zixun(){
    this.$alert("更多内容请扫描下载APP体验", "", {
        confirmButtonText: "确定",
        showClose:false
    });
  },
    changeSkuKey: function(sku_key) {
      this.sku_key = sku_key;
    },
    getProductDetail: function() {
      var that = this;
      var id = this.$route.query.id;
      that.id = id;
      getData(config.apimethod.getProductDetail + "?id=" + id, function(res) {
        var data = res.data;
        that.info = data;
      });
    }
  },
  mounted() {
	this.getProductDetail();
	this.isIE();
  }
};
</script>

<style>
.indexnews .newslist {
  border: none;
  padding: 0 16px;
}
.indexnews .ivu-card-body {
  padding: 0;
}
.abstit {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  text-align: center;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/mall/detail.vue